import { useState } from 'react';
import { ProductClass } from '../../../../types/catalog';

interface ClassAccordionProps {
    classes: ProductClass[];
    classId: string | null;
    setClassId: (id: string | null) => void;
}

function ClassAccordion({ classes, classId, setClassId }: ClassAccordionProps) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div
            className={
                'iek-prodcat-catalog-section-filter-block' +
                (!isOpen ? ' iek-prodcat-catalog-section-filter-block_collapsed' : '')
            }
        >
            <table
                className="iek-prodcat-catalog-section-filter-block__title"
                onClick={() => setIsOpen(!isOpen)}
            >
                <tbody>
                    <tr>
                        <td className="iek-prodcat-catalog-section-filter-block__name-wrap">
                            <div className="iek-prodcat-catalog-section-filter-block__name iek-prodcat-catalog-section-filter-block__name_italic">
                                Выберите вид товара для перехода к подбору по параметрам
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="iek-prodcat-catalog-section-filter-values iek-prodcat-catalog-section-filter-values_long">
                <ul>
                    {classes.map(({ name, id }, idx) => (
                        <li key={idx} style={{ marginTop: '4px' }}>
                            <span
                                style={{ fontWeight: id === classId ? 'bold' : undefined }}
                                onClick={() => setClassId(id === classId ? null : id)}
                            >
                                {name}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ClassAccordion;
